import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateMenuFilter } from '../../actions/sideMenuAction';

const useFilterSideMenu = (menuId, isEnabled) => {
  const dispatch = useDispatch();
  
  useEffect(() => {
    if (!menuId || typeof isEnabled !== 'boolean') return;
    
    dispatch(updateMenuFilter(menuId, isEnabled));
  }, [dispatch, menuId, isEnabled]);
};

export default useFilterSideMenu;
